import FeaturedPost from './featuredpost'

function BigFeaturedPost(props) {
    return (
        <FeaturedPost content={props.content} height="800px"></FeaturedPost >
    )
}

export default BigFeaturedPost